
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Layout from '../../../components/docs/Layout';
export const metadata = {
  toc: true,
  description: 'View institutions and institution test configurations available in the Sandbox. Learn how to prompt various Auth flows by using specific credentials.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Header title='Sandbox institutions' subtitle='View institutions and institution test configurations available in the Sandbox' mdxType="Header" />
    <h4 {...{
      "id": "institution-details"
    }}>{`Institution details`}</h4>
    <p>{`All of the institutions that are available in the Plaid Production environment are also available in Sandbox. Plaid also provides several Sandbox-only institutions to write integration tests against:`}</p>
    <Layout.FullWidth>
      <table>
        <thead parentName="table">
          <tr parentName="thead">
            <th parentName="tr" {...{
              "align": null
            }}>{`Institution name`}</th>
            <th parentName="tr" {...{
              "align": null
            }}>{`ID`}</th>
          </tr>
        </thead>
        <tbody parentName="table">
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`First Platypus Bank (non-OAuth bank)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_109508`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`First Platypus Balance Bank (non-OAuth bank)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_130016`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`First Gingham Credit Union (non-OAuth bank)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_109509`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Tattersall Federal Credit Union (non-OAuth bank)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_109510`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Tartan Bank (non-OAuth bank)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_109511`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Houndstooth Bank (for Instant Match and Automated Micro-deposits testing)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_109512`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Tartan-Dominion Bank of Canada (Canadian bank)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_43`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Flexible Platypus Bank (non-OAuth bank)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_116834`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Royal Bank of Plaid (UK Bank)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_117650`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Platypus OAuth Bank (for `}<a parentName="td" {...{
                "href": "/docs/link/oauth/#testing-oauth"
              }}>{`OAuth testing`}</a>{`)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_127287`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`First Platypus Bank - OAuth (for `}<a parentName="td" {...{
                "href": "/docs/sandbox/#consent-expiration"
              }}>{`consent expiration testing`}</a>{`)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_129644`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`First Platypus Bank - OAuth App2App (for `}<a parentName="td" {...{
                "href": "/docs/link/oauth/#app-to-app-authentication"
              }}>{`App-to-App OAuth testing`}</a>{`)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_132241`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Flexible Platypus Open Banking (UK Bank, for `}<a parentName="td" {...{
                "href": "/docs/link/oauth/#qr-code-authentication"
              }}>{`OAuth QR code authentication`}</a>{` testing)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_117181`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Windowpane Bank (for `}<a parentName="td" {...{
                "href": "/docs/auth/coverage/instant/#instant-micro-deposits"
              }}>{`Instant Micro-deposits testing`}</a>{`)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_135858`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`First Platypus Limited Purpose (for testing `}<a parentName="td" {...{
                "href": "/docs/auth/#enabling-limited-purpose-checking-accounts-for-rent-or-mortgage"
              }}>{`limited purpose depository accounts`}</a>{`)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_138395`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Unhealthy Platypus Bank - Degraded`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_132363`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Unhealthy Platypus Bank - Down`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_132361`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Unsupported Platypus Bank - Institution Not Supported`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_133402`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Platypus Bank RUX Auth (formerly for testing legacy RUX flows)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_133502`}</inlineCode></td>
          </tr>
          <tr parentName="tbody">
            <td parentName="tr" {...{
              "align": null
            }}>{`Platypus Bank RUX Match (formerly for testing legacy RUX flows)`}</td>
            <td parentName="tr" {...{
              "align": null
            }}><inlineCode parentName="td">{`ins_133503`}</inlineCode></td>
          </tr>
        </tbody>
      </table>
    </Layout.FullWidth>
    <p>{`All Sandbox institutions can be accessed using the `}<a parentName="p" {...{
        "href": "/docs/sandbox/test-credentials"
      }}>{`Sandbox test credentials`}</a>{`.`}</p>
    <p>{`Note that when testing OAuth in Sandbox, the OAuth flow for Platypus will be shown instead of institution-specific flows, and institution-specific behaviors will not occur, except at test institutions as shown above.`}</p>
    <p>{`None of the institutions in the list above use OAuth flows except for those that are explicitly marked as OAuth or European / UK institutions.`}</p>
    <h4 {...{
      "id": "institution-details-for-auth-testing"
    }}>{`Institution details for Auth testing`}</h4>
    <p>{`You can trigger specific Auth flows in the Sandbox environment by using the following values.
For detailed instructions on testing Auth in the Sandbox, see `}<a parentName="p" {...{
        "href": "/docs/auth/coverage/testing/"
      }}>{`Testing Auth in the Sandbox`}</a>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Step`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Instant Match`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Automated Micro-deposits`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Same-Day Micro-deposits`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Instant Micro-deposits`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Institution`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Houndstooth Bank`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Houndstooth Bank`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Windowpane Bank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Username`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`user_good`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`user_good`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Password`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`pass_good`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`microdeposits_good`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Plaid Saving (`}{`*`}{`*`}{`*`}{`*`}{`1111)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Plaid Checking (`}{`*`}{`*`}{`*`}{`*`}{`0000)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Checking or Savings`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Checking or Savings`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Routing number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`021000021`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`021000021`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`110000000`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`333333334`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Account number`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1111222233331111`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1111222233330000`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1111222233330000`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`1111222233330000`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Micro-deposit code`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`N/A`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ABC`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`ABC`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Wait before Sandbox verification`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Instant`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`About 24 hours`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Verify interactively within minutes`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Instant`}</td>
        </tr>
      </tbody>
    </table>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "institution-details",
        level: 4,
        title: "Institution details",
      },
{
        id: "institution-details-for-auth-testing",
        level: 4,
        title: "Institution details for Auth testing",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
